import { Injectable } from '@angular/core'
import { Actions, Effect } from '@ngrx/effects'
import { Action } from '@ngrx/store'
import { EnrolmentService, FetchEnrolmentsParams, SetRolloverParams, ChangeClassParams, DisenrolmentParams } from "@services/enrolment"
import { MatrixClassService } from "@services/matrix-class"
import { ContactService } from "@services/contact"
import { MatrixClass } from "@models/matrix-class"
import { Enrolment } from "@models/enrolment"
import { Contact } from "@models/contact"
import { Observable } from 'rxjs/Observable'
import {
  FETCH_POTENTIAL_CLASSES,
  FETCH_POTENTIAL_CLASSES_FAILURE,
  POPULATE_POTENTIAL_CLASSES,
  FETCH_ENROLMENT_SELECTED_CLASS,
  POPULATE_SELECTED_CLASS,
  FETCH_ENROLMENT_SELECTED_CLASS_FAILURE,
  FETCH_ENROLMENT_SELECTED_CONTACT_FAILURE,
  POPULATE_ENROLMENT_SELECTED_CONTACT,
  FETCH_ENROLMENT_SELECTED_CONTACT,
  CREATE_ENROLMENT,
  ADD_ENROLMENT,
  CREATE_ENROLMENT_FAILURE,
  FETCH_ENROLMENTS,
  FETCH_ENROLMENTS_FAILURE,
  POPULATE_ENROLMENTS,
  FETCH_ENROLMENTS_TO_ROLLOVER,
  POPULATE_ENROLMENTS_TO_ROLLOVER,
  FETCH_ENROLMENTS_TO_ROLLOVER_FAILURE,
  ROLLOVER_ENROLMENTS,
  ROLLOVER_ENROLMENTS_SUCCESS,
  ROLLOVER_ENROLMENTS_FAILURE,
  SET_ROLLOVER_FAILURE,
  SET_ROLLOVER,
  SET_ROLLOVER_SUCCESS,
  CHANGE_CLASS_ON_ENROLMENT,
  CHANGE_CLASS_ON_ENROLMENT_SUCCESS,
  CHANGE_CLASS_ON_ENROLMENT_FAILURE,
  PERFORM_DISENROLMENT_SUCCESS,
  PERFORM_DISENROLMENT_FAILURE,
  PERFORM_DISENROLMENT
} from "../enrolments"

@Injectable()
export class EnrolmentEffects {

  constructor(
    private actions: Actions,
    private enrolmentService: EnrolmentService,
    private matrixClassService: MatrixClassService,
    private contactService: ContactService,
  ) {}

  @Effect() fetchEnrolments = this.actions
    .ofType(FETCH_ENROLMENTS)
    .map((action: Action) => action.payload)
    .switchMap((params: FetchEnrolmentsParams) => this.enrolmentService.fetchEnrolments(params)
      .map((enrolments: Enrolment[]) => ({ type: POPULATE_ENROLMENTS, payload: enrolments }))
      .catch((response) => Observable.of({ type: FETCH_ENROLMENTS_FAILURE, payload: response }))
    )
    .share()

  @Effect() createEnrolment = this.actions
    .ofType(CREATE_ENROLMENT)
    .map((action: Action) => action.payload)
    .switchMap((enrolment: Enrolment) => this.enrolmentService.createEnrolment(enrolment.serializeForRails())
      .map((enrolment: Enrolment) => ({ type: ADD_ENROLMENT, payload: enrolment }))
      .catch((response) => Observable.of({ type: CREATE_ENROLMENT_FAILURE, payload: response }))
    )
    .share()

  @Effect() fetchPotentialClasses = this.actions
    .ofType(FETCH_POTENTIAL_CLASSES)
    .map((action: Action) => action.payload)
    .switchMap((params: any) => this.matrixClassService.index(params)
      .map((matrixClasses: MatrixClass[]) => ({ type: POPULATE_POTENTIAL_CLASSES, payload: matrixClasses }))
      .catch(() => Observable.of({ type: FETCH_POTENTIAL_CLASSES_FAILURE }))
    )
    .share()

  @Effect() fetchSelctedClass = this.actions
    .ofType(FETCH_ENROLMENT_SELECTED_CLASS)
    .map((action: Action) => action.payload)
    .switchMap((id: number) => this.matrixClassService.fetch(id)
      .map((matrixClass: MatrixClass) => ({ type: POPULATE_SELECTED_CLASS, payload: matrixClass }))
      .catch(() => Observable.of({ type: FETCH_ENROLMENT_SELECTED_CLASS_FAILURE }))
    )
    .share()

  @Effect() fetchSelectedContact = this.actions
    .ofType(FETCH_ENROLMENT_SELECTED_CONTACT)
    .map((action: Action) => action.payload)
    .switchMap((id: number) => this.contactService.fetch(id)
      .map((contact: Contact) => ({ type: POPULATE_ENROLMENT_SELECTED_CONTACT, payload: contact }))
      .catch(() => Observable.of({ type: FETCH_ENROLMENT_SELECTED_CONTACT_FAILURE }))
    )
    .share()

  @Effect() fetchEnrolmentsToRollover = this.actions
    .ofType(FETCH_ENROLMENTS_TO_ROLLOVER)
    .map((action: Action) => action.payload)
    .switchMap((params: FetchEnrolmentsParams) => this.enrolmentService.fetchEnrolments(params)
      .map((enrolments: Enrolment[]) => ({ type: POPULATE_ENROLMENTS_TO_ROLLOVER, payload: enrolments }))
      .catch(() => Observable.of({ type: FETCH_ENROLMENTS_TO_ROLLOVER_FAILURE }))
    )
    .share()

  @Effect() setRollover = this.actions
    .ofType(SET_ROLLOVER)
    .map((action: Action) => action.payload)
    .switchMap((payload: SetRolloverParams) => this.enrolmentService.setRollover(payload)
      .map(() => ({ type: SET_ROLLOVER_SUCCESS }))
      .catch(() => Observable.of({ type: SET_ROLLOVER_FAILURE }))
    )
    .share()

  @Effect() rolloverEnrolments = this.actions
    .ofType(ROLLOVER_ENROLMENTS)
    .switchMap(() => this.enrolmentService.rolloverEnrolments()
      .map(() => ({ type: ROLLOVER_ENROLMENTS_SUCCESS }))
      .catch(() => Observable.of({ type: ROLLOVER_ENROLMENTS_FAILURE }))
    )
    .share()

  @Effect() changeClass = this.actions
    .ofType(CHANGE_CLASS_ON_ENROLMENT)
    .map((action: Action) => action.payload)
    .switchMap((payload: ChangeClassParams) => this.enrolmentService.changeClass(payload)
      .map(() => ({ type: CHANGE_CLASS_ON_ENROLMENT_SUCCESS }))
      .catch(() => Observable.of({ type: CHANGE_CLASS_ON_ENROLMENT_FAILURE }))
    )
    .share()

  @Effect() disenrol = this.actions
    .ofType(PERFORM_DISENROLMENT)
    .map((action: Action) => action.payload)
    .switchMap((payload: DisenrolmentParams) => this.enrolmentService.disenrol(payload)
      .map(() => ({ type: PERFORM_DISENROLMENT_SUCCESS }))
      .catch(() => Observable.of({ type: PERFORM_DISENROLMENT_FAILURE }))
    )
    .share()

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/enrolment.ts